import { LetterbooksSerializersLetterbooks } from "types/serializers";
import { LetterbookSettingType } from "../types";
import { findConditions } from "./conditions/findConditions";
import { findOrderOptions } from "./order";
import findTableColumns from "./views/findTableColumns";

export default function parseSettingsFromContext(
  context: LetterbooksSerializersLetterbooks
): LetterbookSettingType {
  const { searchParams } = context;
  const { orderOptions, order } = findOrderOptions(context);
  const conditions = findConditions(context);
  const { tableColumns, unusedColumns } = findTableColumns(context);

  return {
    conditions,
    limit: Number(searchParams.limit) || 100,
    order,
    orderOptions,
    start: Number(searchParams.start) || 0,
    type: context.type,
    url: context.url,
    view: context.view,
    context: context.context,
    searchParams,
    tableColumns,
    unusedColumns,
  };
}
